import { DE$ } from '@infl-ts/util-datum';
import { constant, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import { createContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var defaultConfig = {
  messagingEnabled: false
};
export var PopoverConfigContext = /*#__PURE__*/createContext({
  config: defaultConfig
});
export var PopoverConfigProvider = function PopoverConfigProvider(_ref) {
  var popoverConfig = _ref.popoverConfig,
      children = _ref.children;
  return pipe(popoverConfig, DE$.getSuccessOrElse(O.some(defaultConfig)), O.getOrElse(constant(defaultConfig)), function (config) {
    return /*#__PURE__*/_jsx(PopoverConfigContext.Provider, {
      value: {
        config: config
      },
      children: children
    });
  });
};